import { AfterViewChecked, AfterViewInit, Directive, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[fx-head]'
})
export class FixedHeaderDirective implements AfterViewInit, OnInit {
  fixedTable;
  timerHandler;
  domTimerManager;
  initialized = false;

  @Input('changeHeader') changeHeader: Subject<boolean>;

  @Input('sortHeaders') sortHeaders: string[] = [];

  @Input('sortedHeader') sortedHeader: any = {};

  @Output('sortEvent') sortEvent = new EventEmitter<any>(null);

  constructor(private renderer: Renderer2, private el: ElementRef) {
  }

  ngOnInit() {
    if (this.changeHeader) {
      this.changeHeader.pipe(
        debounceTime(100)
      ).subscribe(response => {
        // console.log("Hi");
        this.initHeaders();
      })
    }
  }
  ngAfterViewInit() {
    this.initHeaders('firstInit');
    this.initialized = true;
  }

  initHeaders(type?:string) {
    let parent = this.el.nativeElement;

    let sortedElemText = null;
    let touchedElem = null;

    let prevCloned = parent.querySelector('.cloned_table_fx_head');
    if (prevCloned) {
      sortedElemText = prevCloned.querySelector('tr th[data-info="asc"]') ? prevCloned.querySelector('tr th[data-info="asc"]').querySelector('div').getAttribute('data-key').toLowerCase() : null;
      touchedElem = prevCloned.querySelector('.fx_tr_touched')?.querySelector('div').getAttribute('data-key').toLowerCase();
      prevCloned.remove();

      let pths = parent.querySelector('thead tr').children;
      for (let i = 0; i < pths.length; i++) {
        let item = pths[i].querySelector('div');
        this.renderer.setStyle(pths[i], 'width', 'auto')
        this.renderer.setStyle(item, 'width', '100%')
      }
    }



    let styles = window.getComputedStyle(parent)
    if (styles.position == 'static') {
      this.renderer.setStyle(parent, 'position', 'relative');
    }
    let totalGap = parent.scrollTop + parseFloat(styles.paddingLeft.substring(0, styles.paddingLeft.length - 2)) + parseFloat(styles.paddingRight.substring(0, styles.paddingLeft.length - 2))

    let prevTable = parent.querySelector('table');
    let prevTableHead = parent.querySelector('table thead');
    let fixedTableHeader = prevTableHead.cloneNode(true);
    let pths = prevTable.querySelector('tr').children;
    let fths = fixedTableHeader.querySelector('tr').children;
    for (let i = 0; i < pths.length; i++) {
      let itemRow = pths[i];
      let itemRowStyles = window.getComputedStyle(itemRow);
      let fitemRow = fths[i];
      this.renderer.setStyle(fitemRow, 'width', itemRowStyles.width)
      this.renderer.setStyle(itemRow, 'width', itemRowStyles.width)


      let item = pths[i].querySelector('div');
      let itemStyles = window.getComputedStyle(item);
      let fitem = fths[i].querySelector('div');
      this.renderer.setStyle(fitem, 'width', itemStyles.width)
      this.renderer.setStyle(item, 'width', itemStyles.width)
      // console.log(fths[i].querySelector('div'), pths[i].width);
      // console.log(pths[i].querySelector('div'), fths[i].offsetWidth);

      if (this.sortHeaders.length > 0 && this.sortHeaders.find(header => header.toLowerCase() === fitemRow.querySelector('div').getAttribute('data-key').toLowerCase())) {
        this.configSort(fitemRow, fixedTableHeader, sortedElemText, touchedElem, type)
      }

    }


    // create new table as fixed
    this.fixedTable = this.renderer.createElement('table');
    this.renderer.setStyle(this.fixedTable, 'position', 'sticky');
    this.renderer.setStyle(this.fixedTable, 'background', '#fff');
    // this.renderer.setStyle(this.fixedTable, 'transition', '.2s linear');
    this.renderer.setStyle(this.fixedTable, 'top', 0);
    this.renderer.setStyle(this.fixedTable, 'left', 0);
    this.renderer.setStyle(this.fixedTable, 'z-index', 2);
    this.renderer.setStyle(this.fixedTable, 'max-width', 'calc(100% - ' + totalGap + 'px)');
    prevTable.classList.forEach(x => {
      this.renderer.addClass(this.fixedTable, x);
    })
    this.renderer.addClass(this.fixedTable, 'cloned_table_fx_head');
    this.renderer.appendChild(this.fixedTable, fixedTableHeader);

    this.renderer.insertBefore(this.el.nativeElement, this.fixedTable, prevTable);


    let fstyles = window.getComputedStyle(this.fixedTable);
    this.renderer.setStyle(prevTable, 'margin-top', '-' + fstyles.height);
  }

  configSort(row, header, sortedElem, touchedElem, type) {

    // console.log(sortedElem, touchedElem);
    
    // initializations
    row.style.cursor = 'pointer';
    let span = document.createElement('span');
    span.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><defs><style>.a{fill:none;}.b{fill:#cbcbcb;}</style></defs><rect class="a" width="20" height="20"/><g transform="translate(0 0.3)"><g transform="translate(5 11.7)"><path class="b top" d="M5,5.7H5a1,1,0,0,1-.745-.3L.319,1.7a.927.927,0,0,1,0-1.4A1.074,1.074,0,0,1,1.809.3L5,3.3,8.191.3A1.074,1.074,0,0,1,9.681.3a.927.927,0,0,1,0,1.4L5.745,5.4A1.188,1.188,0,0,1,5,5.7Z" transform="translate(0 -1)"/></g><path class="b bottom" d="M5,5.7H5a1,1,0,0,1-.745-.3L.319,1.7a.927.927,0,0,1,0-1.4A1.074,1.074,0,0,1,1.809.3L5,3.3,8.191.3A1.074,1.074,0,0,1,9.681.3a.927.927,0,0,1,0,1.4L5.745,5.4A1.188,1.188,0,0,1,5,5.7Z" transform="translate(15 8.7) rotate(180)"/></g></svg>`;
    this.renderer.appendChild(row.querySelector('div'), span);

    if (touchedElem && row.querySelector('div').getAttribute('data-key').toLowerCase().trim() == touchedElem) {
      this.renderer.addClass(row, 'fx_tr_touched');
    }

    if (sortedElem && row.querySelector('div').getAttribute('data-key').toLowerCase().trim() == sortedElem.toLowerCase()) {
      this.renderer.setAttribute(row, 'data-info', 'asc');
      this.renderer.addClass(row.querySelector('span'), 'ascending');
    } else {
      this.renderer.setAttribute(row, 'data-info', 'desc');
      this.renderer.addClass(row.querySelector('span'), 'descending');
      // this.removeAscendingClass(row);
      // this.removeDescendingClass(row);
    }

    if(type && Object.keys(this.sortedHeader).length === 2 && this.sortedHeader.header.toLowerCase() == row.querySelector('div').getAttribute('data-key').toLowerCase().trim()) {
    this.renderer.addClass(row, 'fx_tr_touched');
      this.renderer.setAttribute(row, 'data-info', this.sortedHeader.order);
      this.renderer.addClass(row.querySelector('span'), this.sortedHeader.order == 'asc' ?  'ascending' : 'descending');
      this.sortedHeader.order == 'asc' ? this.removeDescendingClass(row) : this.removeAscendingClass(row)
    }

    // click event listners
    this.renderer.listen(row, 'click', (event) => {

      for (let elem of header.querySelector('tr').children) {

        if (elem.getAttribute('data-info')) {

          if (elem.querySelector('div').getAttribute('data-key').toLowerCase() === row.querySelector('div').getAttribute('data-key').toLowerCase()) {

            if (row.getAttribute('data-info') == 'desc') {

              this.renderer.addClass(row.querySelector('span'), 'ascending');
              this.removeDescendingClass(row);

            } else {
              this.renderer.addClass(row.querySelector('span'), 'descending');
              this.removeAscendingClass(row);

            }

            this.renderer.setAttribute(row, 'data-info', row.getAttribute('data-info') == 'desc' ? 'asc' : 'desc');
            this.renderer.addClass(row, 'fx_tr_touched');

            this.sortEvent.next({
              header: this.sortHeaders.find(header => header.toLowerCase() == row.querySelector('div').getAttribute('data-key').toLowerCase()),
              order: row.getAttribute('data-info')
            });

          } else {
            this.renderer.setAttribute(elem, 'data-info', 'desc');
            this.removeAscendingClass(elem);
            this.removeDescendingClass(elem);

            if (elem.classList.contains('fx_tr_touched'))
              this.renderer.removeClass(elem, 'fx_tr_touched');
          }

        }

      }
    });
  }

  removeAscendingClass(row: any) {
    if (row.querySelector('span')?.classList.contains('ascending'))
      this.renderer.removeClass(row.querySelector('span'), 'ascending');
  }
  removeDescendingClass(row: any) {
    if (row.querySelector('span')?.classList.contains('descending'))
      this.renderer.removeClass(row.querySelector('span'), 'descending');
  }
}
